import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FabAction, FabService } from "./fab.service";

@Component({
  selector: "app-fab",
  templateUrl: "./fab.component.html",
  styleUrls: ["./fab.component.scss"],
})
export class FabComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  actions: FabAction[] = [];

  constructor(public fab: FabService) {}

  ngOnInit(): void {
    this.fab.actions$.pipe(takeUntil(this.destroy$)).subscribe((a) => {
      this.actions = a || [];
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  run(a: FabAction): void {
    try {
      a.onClick?.();
    } catch (err) {
      console.debug("fab action error:", err);
    }
  }
}
